"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCredentialRefined = void 0;
const buildCredentialRefined = (credential) => ({
    ID: credential.ID,
    metadata: { created: credential.metadata.created, updated: credential.metadata.updated },
    applicant: credential.applicant,
    customAttributes: credential.customAttributes,
    files: credential.files,
    institutionIdentifier: credential.institutionIdentifier,
    links: credential.links,
    parent: credential.parent,
    properties: credential.properties,
    type: credential.type,
    verification: credential.verification,
});
exports.buildCredentialRefined = buildCredentialRefined;
//# sourceMappingURL=CredentialRefined.js.map